import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import { GetScoreDocument, type ProfileScoreTip } from 'src/types/graphql';

interface UITip extends ProfileScoreTip {
  id: string;
}

const buildTips = (tips: ProfileScoreTip[]): UITip[] =>
  tips.map((tip) => ({
    ...tip,
    id: tip.action.card,
  }));

export const useScore = () => {
  const { zone, language: languageCode, isUnifiedSite } = useAppConfig();
  const { data, loading, error } = useQuery(GetScoreDocument, {
    variables: { zone, languageCode, isUnifiedSite },
  });

  const score =
    !loading && !error && data?.viewer?.score
      ? {
          ...data.viewer.score,
          tips: buildTips(data.viewer.score.tips),
        }
      : { tips: [], progress: 1 };

  return { score, loading, error };
};
